import { Button, ButtonGroup, Col, Container, Row } from "react-bootstrap";
import { PencilAltIcon, PrinterIcon, ViewListIcon } from "@heroicons/react/outline";
import PropTypes from "prop-types";

import CourseHeaderFacilitatorActions from "./CourseHeaderFacilitatorActions";
import CourseRegisterButton from "../../../components/CourseRegisterButton";
import ShareClassButton from "../../../components/ShareClassButton";
import { hasRole } from "../../../services/wp.user.service";
import { isHybridEvent } from "../../../helpers/event";
import { useMemo } from "react";

const CourseHeader = ({ course }) => {
	const hybridEvent = useMemo(() => isHybridEvent(course), [course]);
	return (
		<header className="course-header">
			<Container className="bg-primary text-white pt-5 px-lg-5 pb-4" fluid>
				<Row>
					<Col lg={8} md={7} sm={12}>
						<h1 className="text-white mt-4">
							{course.title}
						</h1>

						{course.subTitle ? <div className="mb-2">{course.subTitle}</div> : null}

						<ButtonGroup className="w-100">
							{hasRole(["administrator", "staff"])
								? (
									<>
										<Button href={`/wp-admin/post.php?action=edit&post=${course.id}`}>
											<PencilAltIcon className="i me-2" />
											Edit Class
										</Button>
										<Button href={`/wp-admin/post.php?action=view&post=${course.id}`}>
											<ViewListIcon className="i me-2" />
											View Roster
										</Button>
										<Button href={`/wp-admin/post.php?action=roster&post=${course.id}`} target="_blank">
											<PrinterIcon className="i me-2" />
											Print Roster
										</Button>
									</>
								)
								: hasRole("facilitator")
									? <CourseHeaderFacilitatorActions event={course} />
									: hybridEvent
										? null
										: (
											<CourseRegisterButton
												className="text-white"
												course={course}
												showClosedMessage={false}
												variant="link"
											/>)}
							<ShareClassButton className="px-0 text-white" course={course} variant="link" />
						</ButtonGroup>

						{
							hybridEvent && !hasRole(["administrator", "staff", "facilitator"])
								? (
									<CourseRegisterButton
										course={course}
										groupClassName="w-100"
										showClosedMessage={false}
										variant="success"
									/>
								) : null
						}
					</Col>
				</Row>
			</Container>
		</header>
	);
};

CourseHeader.propTypes = {
	course: PropTypes.shape({
		description: PropTypes.string,
		id: PropTypes.number,
		subTitle: PropTypes.string,
		title: PropTypes.string.isRequired
	}).isRequired
};

export default CourseHeader;
